const MatchTeamStatus = {
  forfeit: "FORFEIT",
};

export default MatchTeamStatus;
